

export default function toUnicode(str) {
    let a = str.replace("&", "%26").replace(/ /g,"%20");
    return a;
}